<template>
  <div id="Part04">
    <p class="title">
      <img src="./img/title.png" alt="">
    </p>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Part04',
  mounted () {
    this.$bgAudio.play()
  },
  beforeDestroy () {
    this.$bgAudio.pause()
  },
}
</script>

<style lang="scss" scoped>
#Part04 {
  height: 100%;
  background-image: url(./img/bg.jpg);
  background-size: 100% 100%;
  .title {
    position: relative;
    top: 0.6rem;
    height: 0.8rem;
    text-align: center;
    & > img {
      height: 100%;
    }
  }
}
</style>
